import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import IconFA from "../../../../components/icon/icon";
import Button from "../../../../components/button/button";
import { useUserContext } from "../../../utils/userContext";
import EditUser from "./editUser";

function UserDetail() {
    const { id } = useParams();
    const { userDetail, fetchUserDetail } = useUserContext();
    const user = userDetail?.data || {};
    const customers = user.customers || [];
    const invoices = user.invoices || [];
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        fetchUserDetail(id);        
    }, [id]);

    function formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    }

    return (
        <div className="adUsDePageContainer">
            {!editMode && (
                <>
                    <div className="adUsDeHeader">
                        <Link to='/admin/user'><IconFA iconName='arrowLeft' /></Link>
                        <h1>Übersicht: {user.prename} {user.name}</h1>
                    </div>
                    <div className="adUsDeContentContainer">
                        <div className="adUsDeHeadingContainer"><h3>Userdaten</h3></div>
                        <p><b>Account:</b> {user.active === undefined ? 'Unbekannt' : (user.active ? 'aktiv' : 'inaktiv')}</p>
                        <p><b>Firma:</b> {user.companyName || 'Kein Firmenname angegeben'}</p>
                        <p><b>Email:</b> {user.email || 'Keine Email angegeben'}</p>
                        <p><b>Telefon:</b> {user.phoneNumber || 'Keine Telefonnummer angegeben'}</p>
                        <p><b>Adresse:</b> {user.address || 'Keine Adresse angegeben'}</p>
                        <p><b>Adresszusatz:</b> {user.addressAdition || 'Kein Adresszusatz angegeben'}</p>
                        <p><b>Postleitzahl:</b> {user.postCode || 'Keine Postleitzahl angegeben'}</p>
                        <p><b>Stadt:</b> {user.town || 'Keine Stadt angegeben'}</p>
                        <p><b>Website:</b> {user.website || 'Keine Website angegeben'}</p>
                        <p><b>Rolle:</b> {user.role || 'Keine Rolle angegeben'}</p>
                        <p><b>Angemeldet am:</b> {formatDate(user.signedUpAt)}</p>
                        <p><b>Kunden:</b> {customers.length}</p>
                        <p><b>Rechnungen:</b> {invoices.length}</p>
                        <p><b>Kundenstatusliste:</b> {Array.isArray(user.customerStatusList) ? user.customerStatusList.join(', ') : 'Keine Liste vorhanden'}</p>
                        <p><b>Abo:</b> {user.subscription || 'Kein Abo angegeben'}</p>
                        <p><b>Email bestätigt:</b> {user.emailConfirmed ? 'Ja' : 'Nein'}</p>
                        <p><b>Onboarding abgeschlossen:</b> {user.onboardCompleted ? 'Ja' : 'Nein'}</p>
                        <p><b>Steuernummer:</b> {user.taxNumber || 'Keine Steuernummer angegeben'}</p>
                        <p><b>Finanzamt:</b> {user.taxOffice || 'Kein Finanzamt angegeben'}</p>
                        <p><b>Bank:</b> {user.bank || 'Keine Bank angegeben'}</p>
                        <p><b>IBAN:</b> {user.iban || 'Kein IBAN angegeben'}</p>
                        <p><b>BIC:</b> {user.bic || 'Kein BIC angegeben'}</p>
                        <Button 
                            buttonValue='Benutzer bearbeiten'
                            onClick={() => setEditMode(true)}
                         />
                        <Button buttonValue='Passwort zurücksetzen' />
                    </div>
                </>
            )}
            {editMode && (
                <EditUser 
                    user={user}
                    onCancel={() => setEditMode(false)}
                />
            )}
        </div>
    );
}

export default UserDetail;